module.exports = __webpack_public_path__ + "static/img/b-2.28e0d83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/b-2.png
// module id = 9rZP
// module chunks = 0